goog.provide('el8.appchart.mainFeeds.outstanding');

goog.require('el8.appchart.mainFeeds.reqActRenderer');
goog.require('el8.appchart.mainFeeds.actions');
goog.require('el8.appchart.mainFeeds.outstandingReactRenderMap');
goog.require('el8.uiwidget.Feed');
goog.require('el8.ptdata.fetch');
goog.require('el8.template.appchart.mainFeeds');

goog.require('el8.appshared.message');
goog.require('el8.appshared.signOff');
goog.require('el8.appshared.react.renderNewMessageThread');

/**
 * See https://github.com/elationemr/hippo/wiki/Chart-Feed
 * for an overview of the various pieces of the chart feed,
 * which largely apply here as well (although the outstanding
 * items feed reuses the same renderers as requiring action).
 */
if (el8Globals['APP'].startswith('chart')) {
    el8.appchart.mainFeeds.outstanding = (function() {
        var name = 'outstanding';

        var feed = new el8.uiwidget.Feed({
            container: $('#outstanding-feed-container'),
            name: name,
            urlIndex: el8Globals['PATIENT_PATH'] + 'outstanding-feed-index/',
            rendererFn: el8.appchart.mainFeeds.reqActRenderer,
            reactRenderMap: el8.appchart.mainFeeds.outstandingReactRenderMap,
            fetchFn: el8.ptdata.fetch,
            skeletonFn: el8.template.appchart.mainFeeds.outstanding,
            clickTriggerMap: el8.appchart.mainFeeds.actions.clickMap,
            addlRenderItemFn: function(renderedItem, item) {
                if (!item) return;

                if (item.is('RxHistoryDownloadSummary')) {
                    // TODO: this is ugly. We're updating the rendering of the LHS because
                    // we're using this point to know that the rx download summary is now available.
                    // It would be better to use an event listener instead.
                    el8.appchart.refpanel.meds.renderRxDownload();
                } else if (item.is('Letter') || item.is('LetterReceipt')) {
                    el8.appshared.letterFeedRenderer.render(renderedItem, item, false);
                }
                if (item.is('MessageThread') && el8Globals.FEATURES.NewOfficeMessages) {
                    el8.appshared.react.renderNewMessageThread(renderedItem, {
                        feedName: name,
                        messages: [item.asSoyMap(true)],
                        itemId: item.getId(),
                        onReplySuccess: function refresh(data) {
                            el8.ptdata.messageThreads.create(data);
                        }
                    });
                }
            },
            addlResetItemFn: function(item, renderedItem) {
                if (!item) return;

                if (item.is('Letter') || item.is('LetterReceipt')) {
                    el8.appshared.letterFeedRenderer.reset(renderedItem, item);
                }
            }
        });

        return feed;

    })();
}
